// The one place that knows the browser Maps key.
//
// It used to be spelled three ways: read from the env var alone (which was
// undefined, because .env sat in src/ where CRA never looks), read with a
// hardcoded fallback, and hardcoded outright. The first spelling produced a
// grey "for development purposes only" map, because passing an undefined key
// to the Maps JS loader is the same as passing no key.
//
// The fallback stays deliberately: it is what kept the other maps working
// through the misplaced .env, and it costs nothing now that the env var
// resolves. A browser Maps key is public regardless — it ships in the bundle
// — so the real protection is the HTTP-referrer restriction set on the key in
// Google Cloud Console, not secrecy here.
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  "AIzaSyBjgK-bezlAjIF6PUj_239Ln9jYSaO_A30";

// Every @react-google-maps/api consumer must pass the SAME id, or the library
// tears down and reloads the Maps script when you navigate between two pages
// that use it — which shows up as a map that flashes blank.
export const GOOGLE_MAPS_LOADER_ID = "medstown-google-maps";

export default GOOGLE_MAPS_API_KEY;
